import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 8rem;
  margin-bottom: 10rem;
  min-height: 900px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media (max-width: 1000px) {
    flex-direction: column;
    margin-top: 2rem;
    margin-bottom: 3rem;
  }
`;

// About
export const TextBlock = styled.div`
  width: 45%;
  @media (max-width: 1400px) {
    width: 40%;
  }
  @media (max-width: 1000px) {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const ImageBlock = styled.div`
  position: relative;
  margin-left: 80px;
  width: 50%;
  @media (max-width: 1400px) {
    width: 60%;
  }
  @media (max-width: 1000px) {
    width: 100%;
    height: 400px;
    margin: 0;
  }
`;

export const Frame = styled.div`
  box-sizing: border-box;
  position: absolute;
  right: 0;
  bottom: 80px;
  height: calc(100% - 80px);
  width: 80%;
  border: 25px solid #982822;
  @media (max-width: 1000px) {
    width: 100%;
    height: 350px;
    bottom: 40px;
    right: -40px;
    height: calc(100% - 40px);
  }
`;
export const Image = styled.div`
  position: absolute;
  width: 80%;
  height: calc(100% - 80px);
  top: 80px;
  right: 80px;
  > img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
  @media (max-width: 1000px) {
    width: 100%;
    height: 400px;
    margin: 0;
    top: 40px;
    right: 0px;
    height: calc(100% - 40px);
  }
`;

export const Floral = styled.img`
  position: absolute;
  width: 100%;
  transform: translate(0, -54%);
`;
export const AboutBlock = styled.div`
  width: 100%;
  @media (max-width: 1000px) {
    width: 100%;
    order: 2;
  }
`;

export const MenuBlock = styled.div`
  position: relative;
  a {
    text-decoration: none;
  }
  @media (max-width: 1000px) {
    width: 100%;
    order: 1;
    margin-bottom: 2rem;
  }
`;

export const Paragraph = styled.p`
  margin-bottom: 4rem;
  text-align: center;
  @media (max-width: 1000px) {
    width: 100%;
    margin-bottom: 3rem;
  }
`;

export const Article = styled.a`
  font-size: 23px;
  @media (max-width: 1000px) {
    font-size: 18px;
  }
`;

export const Small = styled.p`
  font-size: 15px;
  text-align: center;
`;

// Menu

export const MenuTitle = styled.li`
  font-weight: 600;
  font-size: 23px;
  color: #982822;
  margin: 2rem 0;
  text-transform: uppercase;
  @media (max-width: 1300px) {
    font-size: 19px;
  }
`;
